import _sfc_main from './pinyin-menu.vue2.js';
/* empty css                */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const pinyinMenu = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-81920768"]]);

export { pinyinMenu as default };
//# sourceMappingURL=pinyin-menu.js.map
